exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "user-card-list .flex-row{margin:9px 0;display:-moz-flex;display:-ms-flexbox;display:flex}user-card-list .flex-row .flex-item{flex:1}user-card-list .user-card-list.mobile .flex-row{margin:0 0 9px;flex-wrap:wrap}user-card-list .user-card-list.mobile .flex-row .flex-item{flex:1 0 49%;margin-top:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/food-benefit.module/components/userCardList/userCardList.scss
// module id = 1676
// module chunks = 0